import {videoBridgeReportUrls} from "../../api";
import {appendUrlParam, device, mergeParams, parseUrl} from "../util";
import Platform from "../../class/platform";
import App from "../../class/App";

let platform

// 上报 url 列表
export function reportUrlList(urlList) {
    let formattedUrlList = []
    if (Array.isArray(urlList)) {
        urlList.forEach(url => {
            if (typeof url !== "undefined" && url !== null) {
                formattedUrlList.push({type: 1, url})
                console.log('url 已组装：', url, urlList)
            } else {
                console.warn('当前要处理上报的 url 不合法，不再添加到上报队列中：', url, urlList)
            }
        })
    } else {
        console.warn('要上报的数据必须为 array 类型，当前传入的类型为：', typeof urlList, urlList)
    }
    videoBridgeReportUrls(formattedUrlList).then(res => {
        console.log('urlList 已上报：', res, formattedUrlList)
    }).catch(reason => {
        console.error('videoBridgeReportUrls error', reason, formattedUrlList)
    })
}

export function reportBizOnlyImpression() {
    _initPlatformInstance()
    let url = platform.getOnlyImpressionUrl()
    url = appendBizParam(url)
    reportUrlList([url])
}

export function reportBizPvUrls() {
    _initPlatformInstance()
    let urlList = platform.getPvUrls()
    reportUrlList(urlList)
}

export function reportBizImpression({currentCampaign}) {
    let url = currentCampaign && currentCampaign.impression_url
    url = appendBizParam(url)
    reportUrlList([url])
}

export function reportBizNoticeUrl({currentCampaign}) {
    let url = currentCampaign && currentCampaign.notice_url
    url = appendBizParam(url)
    reportUrlList([url])
}

export function reportBizAdTrackingVideoStart({currentCampaign}) {
    let adTracking = currentCampaign && currentCampaign.ad_tracking
    let urlList = adTracking && adTracking.start
    urlList = appendBizParamForUrlList(urlList)
    reportUrlList(urlList)
}

export function reportBizAdTrackingVideoFirstQuartile({currentCampaign}) {
    let adTracking = currentCampaign && currentCampaign.ad_tracking
    let urlList = adTracking && adTracking.first_quartile
    urlList = appendBizParamForUrlList(urlList)
    reportUrlList(urlList)
}

export function reportBizAdTrackingVideoMidpoint({currentCampaign}) {
    let adTracking = currentCampaign && currentCampaign.ad_tracking
    let urlList = adTracking && adTracking.midpoint
    urlList = appendBizParamForUrlList(urlList)
    reportUrlList(urlList)
}

export function reportBizAdTrackingVideoThirdQuartile({currentCampaign}) {
    let adTracking = currentCampaign && currentCampaign.ad_tracking
    let urlList = adTracking && adTracking.third_quartile
    urlList = appendBizParamForUrlList(urlList)
    reportUrlList(urlList)
}

export function reportBizAdTrackingVideoComplete({currentCampaign}) {
    let adTracking = currentCampaign && currentCampaign.ad_tracking
    let urlList = adTracking && adTracking.complete
    urlList = appendBizParamForUrlList(urlList)
    reportUrlList(urlList)
}

/**
 *
 * @param {object}currentCampaign
 * @param {number}rate 当前视频的播放进度百分比
 */
export function reportBizAdTrackingVideoPlayPercentage({currentCampaign, rate}) {
    let adTracking = currentCampaign && currentCampaign.ad_tracking
    let play_percentage = adTracking && adTracking.play_percentage
    if (Array.isArray(play_percentage)) {
        let urlList = play_percentage.filter(obj => obj.rate === rate).map(item => item.url)
        if (urlList.length > 0) {
            console.log('play_percentage urlList: ', rate, urlList)
            urlList = appendBizParamForUrlList(urlList)
            reportUrlList(urlList)
        } else {
            console.warn('当前 rate 符合上报条件的 urlList 为空，不再走后续上报：', rate)
        }
    }
}

export function reportBizAdTrackingVideoMute({currentCampaign}) {
    let adTracking = currentCampaign && currentCampaign.ad_tracking
    let urlList = adTracking && adTracking.mute
    urlList = appendBizParamForUrlList(urlList)
    reportUrlList(urlList)
}

export function reportBizAdTrackingVideoUnmute({currentCampaign}) {
    let adTracking = currentCampaign && currentCampaign.ad_tracking
    let urlList = adTracking && adTracking.unmute
    urlList = appendBizParamForUrlList(urlList)
    reportUrlList(urlList)
}

/**
 * 用户暂停视频上报
 * @param currentCampaign 当前展示的 campaign 素材
 */
export function reportBizAdTrackingVideoPause({currentCampaign}) {
    let adTracking = currentCampaign && currentCampaign.ad_tracking
    let urlList = adTracking && adTracking.pause
    urlList = appendBizParamForUrlList(urlList)
    reportUrlList(urlList)
}

export function reportBizAdTrackingImpression({currentCampaign}) {
    let adTracking = currentCampaign && currentCampaign.ad_tracking
    let urlList = adTracking && adTracking.impression
    urlList = appendBizParamForUrlList(urlList)
    reportUrlList(urlList)
}

export function reportBizAdTrackingClick({currentCampaign}) {
    let adTracking = currentCampaign && currentCampaign.ad_tracking
    let urlList = adTracking && adTracking.click
    urlList = appendBizParamForUrlList(urlList)
    reportUrlList(urlList)
}

/**
 * 提前关闭视频上报
 * @param currentCampaign 当前展示的 campaign 素材
 */
export function reportBizAdTrackingVideoClose({currentCampaign}) {
    let adTracking = currentCampaign && currentCampaign.ad_tracking
    let urlList = adTracking && adTracking.close
    urlList = appendBizParamForUrlList(urlList)
    reportUrlList(urlList)
}

/**
 * endcard show上报
 * @param currentCampaign
 */
export function reportBizAdTrackingEndcardShow({currentCampaign}) {
    let adTracking = currentCampaign && currentCampaign.ad_tracking
    let urlList = adTracking && adTracking.endcard_show
    urlList = appendBizParamForUrlList(urlList)
    reportUrlList(urlList)
}

/**
 * endcard show上报
 * @param currentCampaign
 */
export function reportBizAddRewardToServer({currentCampaign}) {
    if (device().isAndroid) {
        console.warn('当前平台为安卓，由于目前的安卓 SDK 在调用 adClose 的时候自己会报 addReward 给服务端，所以这里 H5 不再重复上报')
        return false
    }
    console.warn('当前平台为 iOS，正常上报 addRewardToServer')

    _initPlatformInstance()
    let addRewardUrl = ''

    let objNoticeUrl = parseUrl(currentCampaign.notice_url);
    let protocol = objNoticeUrl.protocol
    let host = objNoticeUrl.host
    let path = `addReward`;
    let param = {}

    param.unit_id = encodeURIComponent(App && App.initData && App.initData.unit_id)
    param.click_id = encodeURIComponent(objNoticeUrl.params && objNoticeUrl.params.k)
    param.cb_type = '1'
    let rewardInfo = platform.getRewardInfo()
    param.user_id = encodeURIComponent(rewardInfo.userId)
    param.reward_name = encodeURIComponent(rewardInfo.reward && rewardInfo.reward.name || 'Virtual Item')
    param.reward_amount = encodeURIComponent(rewardInfo.reward && rewardInfo.reward.amount || 1)

    addRewardUrl = `${protocol}://${host}/${path}?`
    addRewardUrl += mergeParams(param)

    reportUrlList([addRewardUrl])
}

function appendBizParamForUrlList(urlList) {
    if (!Array.isArray(urlList)) {
        console.warn('当前要上报的业务字段不符合预期，请检查', urlList)
        return urlList
    }

    return urlList.map(url => {
        return appendBizParam(url)
    })
}

/**
 * 在指定 url 中添加通用业务上报参数，并返回处理好的 url
 * 注意：
 * 此方法在业务上会依赖 webviewshow 时更新 expired 状态: updateCampaignExpiredState
 * @param url 要处理的 url
 * @returns {string}
 */
export function appendBizParam(url = '') {
    if (typeof url !== "string") {
        console.warn('当前要上报的业务字段不符合预期，请检查', url)
        return url
    }

    _initPlatformInstance()
    let campaignList = platform.getCampaignList()
    // 注意: 需要保证在 show 时检查完 campaignList 的 isReady 状态之后再调用 onlyImpression Impression 等后续上报
    console.warn('TODO 需要保证在 show 时检查完 campaignList 的 isReady 状态之后再调用 onlyImpression Impression 等后续上报')
    let readyCampaignList = campaignList.filter(c => c.isReady)
    let unitSetting = platform.getUnitSetting()
    let firstCampaign = campaignList && campaignList[0]

    // to 参数初始化, 依赖 webviewshow 时更新 expired 状态: updateCampaignExpiredState
    let key_to = 'to'
    let value_to = platform.getH5Setting().expired ? 1 : 0
    url = appendUrlParam(url, key_to, value_to);

    // tmorl
    // ref: http://confluence.mobvista.com/pages/viewpage.action?pageId=30350188
    let key_tmorl = 'tmorl'
    let value_tmorl = unitSetting && unitSetting.tmorl || 1
    url = appendUrlParam(url, key_tmorl, value_tmorl);

    // cbt
    let key_cbt = 'cbt'
    let value_cbt
    // H5 侧已经实现了 isHitCbp，对应 SDK 侧的 unitSetting.hitcbp
    let isHitcbp = App && App.h5Setting && App.h5Setting.hitcbp || 0

    // 如果超时(to=1)
    if (value_to === 1) {
        // tmorl=1, 则 cbt 上报 1
        if (value_tmorl === 1) {
            // console.log('value_tmorl === 1')
            value_cbt = 1
        }
        // tmorl=2, 则 cbt 上报 0
        else if (value_tmorl === 2) {
            // console.log('value_tmorl === 2')
            value_cbt = 0
        }
    }
    // 如果没有超时(to=0)
    else if (value_to === 0) {
        // 且是 hb 的 offer, 则不走扣回调逻辑, 始终不扣回调
        if (firstCampaign.hb) {
            value_cbt = 0
        }
        // 如果没有超时且不是 hb 的单子, 则需要走扣回调逻辑
        else {
            value_cbt = isHitcbp
        }
    }
    url = appendUrlParam(url, key_cbt, value_cbt);

    // vt viewtogether：
    // 0 表示当前展示的广告没有多广告模板逻辑，只展示一条；
    // 1表示当前展示有多广告逻辑且展示时所有广告达到展示条件；
    // 2表示当前展示有多视频展示逻辑，但因为部分offer资源未加载成功导致只展示部分广告（nscpt 为 0 情况下）
    // 备注：
    // nscpt 的含义
    // 用于控制当前返回的所有广告是否要求 SDK 必须都加载完素材才可展示，默认为1
    // 1 表示需要所有广告都达到ready_rate条件才能展示，
    // 0 表示任意广告达到ready_rate就可以展示
    let key_vt = 'vt'
    let value_vt
    let allLength = campaignList && campaignList.length;
    let readyLength = readyCampaignList && readyCampaignList.length;
    let isAllCampaignReady = allLength === readyLength
    if (isAllCampaignReady) {
        value_vt = 1
    } else {
        value_vt = 2
    }
    url = appendUrlParam(url, key_vt, value_vt);

    // vgc int[] example: [264393623,316549139]
    let key_vgc = 'vgc'
    let value_vgc = readyCampaignList && readyCampaignList.map(c => c.id) || []
    let vgcPrefix = '[';
    let vgcSuffix = ']';
    let separator = ',';
    value_vgc = encodeURIComponent(vgcPrefix.concat(value_vgc.join(separator)).concat(vgcSuffix))
    url = appendUrlParam(url, key_vgc, value_vgc);

    // mof_tplid int
    let key_mof_tplid = 'mof_tplid'
    let value_mof_tplid = campaignList && campaignList[0] && campaignList[0].mof_tplid
    url = appendUrlParam(url, key_mof_tplid, value_mof_tplid);

    return url;
}

function _initPlatformInstance() {
    if (typeof platform === 'undefined') {
        platform = Platform.getInstance()
    }
}